import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PrivatePage, MyAccount } from "@/components";

/**
 * Displays the account page.
 */
const __default__ = {
  name: "MyAccountView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PrivatePage), { "small-window": "" }, {
    default: _withCtx(() => [
      _createVNode(_unref(MyAccount))
    ]),
    _: 1
  }))
}
}

})